import './ComUI.css'

export function bgbutton(text, clickhandle){
    return(
        <div class="background-wrap" style={{marginLeft:'33%'}} onClick={clickhandle}>
            <div class="content">
                <span>{text}</span>
            </div>
        </div>
    )
}